module.exports = __webpack_public_path__ + "img/4(1)(1).adcc8395.png";